import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-suggestion-history',
  templateUrl: './suggestion-history.component.html',
  styleUrls: ['./suggestion-history.component.css']
})
export class SuggestionHistoryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/history/suggestion-history/suggestion-history.component.ts